import { Button, Dropdown } from 'antd';
import { useContext } from 'react';
import { getConfig } from 'utils/helperMethods';
import { UserContext } from 'contexts/ConfigContext';
import { useProfitPoolEvolutionContext } from './context/ProfitPoolEvolutionContext';
import ProfitPoolEvolutionChart from './ProfitPoolEvolutionChart';
import DepletionVsMarginChart from './DepletionVsMarginChart';
import KPIEvolutionChart from './KPIEvolutionChart';
import CustomDropdownButton from 'components/atoms/CustomDropdownButton';
import DownSvg from 'assets/svg/Down';

const ProfitPoolEvolution = () => {
    const { appConfig } = useContext(UserContext);
    const profitPoolConfig = getConfig('profitPool', appConfig);
    const { frequencyList } = profitPoolConfig;

    const { evolutionFrequency, setEvolutionFrequency } = useProfitPoolEvolutionContext();

    return (
        <>
            {/* Granularity Selector */}
            <div className="flex justify-end mb-4">
                <Dropdown
                    menu={{
                        items: frequencyList,
                        onClick: ({ key }: any) => {
                            setEvolutionFrequency(key);
                        },
                    }}
                    trigger={['click']}
                    placement="bottomRight"
                >
                    <CustomDropdownButton type="default">
                        {frequencyList.find((item: any) => item.key === evolutionFrequency)?.label || 'Monthly'}
                        <div className="ml-2">
                            <DownSvg />
                        </div>
                    </CustomDropdownButton>
                </Dropdown>
            </div>

            <div
                className={`border border-borderLinePurpule bg-white p-4  rounded-lg            
            `}
            >
                <div className="mt-4 flex flex-col border border-[#0000000F] rounded-lg px-4 py-2 w-full">
                    <ProfitPoolEvolutionChart />
                </div>

                <div className="mt-4 flex flex-col border border-[#0000000F] rounded-lg px-4 py-2 w-full">
                    <DepletionVsMarginChart />
                </div>
                <div className="mt-4 flex flex-col border border-[#0000000F] rounded-lg px-4 py-2 w-full">
                    <KPIEvolutionChart />
                </div>
            </div>
        </>
    );
};

export default ProfitPoolEvolution;
